export const isSearchingMessagesSelector = (state) => state.searchInMessages.searchMessagesNeeded
export const foundMessagesSelector = (state) => state.searchInMessages.messagesFound
